import { GroupedChartDataPoint } from "../types/chart-data";

/**
 * Calculate the trend line for a given set of data.
 * @param data - The data to calculate the trend line for.
 * @returns The trend line data.
 */
export function calculateTrendLine(
  data: GroupedChartDataPoint[],
): GroupedChartDataPoint[] {
  const n = data.length;
  const sumX = data.reduce((sum, _, i) => sum + i, 0);
  const sumY = data.reduce((sum, item) => sum + item.count, 0);
  const sumXY = data.reduce((sum, item, i) => sum + i * item.count, 0);
  const sumXX = data.reduce((sum, _, i) => sum + i * i, 0);

  const slope = (n * sumXY - sumX * sumY) / (n * sumXX - sumX * sumX);
  const intercept = (sumY - slope * sumX) / n;

  return data.map((item, i) => ({
    ...item,
    trend: Number((slope * i + intercept).toFixed(2)),
  }));
}
